export default __webpack_public_path__ + "static/media/4A4A4AC6-C45E-4D4B-B1EF-C8DBB20CC068_1_105_c.daba485a.jpg";